"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryVehicleById = exports.allPricingFields = void 0;
exports.allPricingFields = `
  customerAdvantage
  customerAdvantageExcludingVat
  customerPrice
  extraDeliveryCharge
  extraImporterSupport
  extraOneTimeFee
  extraWreckage
  importerSupportExcludingVat
  indicativePrice
  indicativePriceExcludingVat
  leasingBasisPrice
  leasingInterestRate
  loanInterestRate
  margin
  netCustomerPrice
  netCustomerPriceIncludingVat
  remainder3630
  remainder3645
  residualValue3y30k
  residualValue3y30kExcludingVat
  residualValue3y45k
  residualValue3y45kExcludingVat
  residualValue3y60k
  residualValue3y60kExcludingVat
  residualValue4y40k
  residualValue4y40kExcludingVat
  residualValue4y60k
  residualValue4y60kExcludingVat
  retailerBasicMargin
  retailerBasicMarginExcludingVat
  retailerCampaignMargin
  retailerCampaignMarginExcludingVat
  retailerMargin
  retailerMarginEquipment
  retailerMarginVehicle
  retailerSupport
  vehicleRoadTax
  vehicleRoadTaxExcludingVat
`;
exports.queryVehicleById = `
  query vehicleById($id: ID!) {
    vehicleById(id: $id) {
      id
      accessories {
        id
        customerPrice
        images {
          url
        }
        manufacturer
        margin
        name
        price
        priceExcludingVat
        sku
      }
      model {
        equipment {
          equipment
        }
        fuel {
          name
          type
        }
        make
        name
        salesArticle
        series
        vehicleType
        year
        pricing {
          importerSupport
          deliveryCharge
          oneTimeFee
          wreckage
          source
          importerSupportExcludingVat
          deliveryChargeExcludingVat
          wreckageExcludingVat
        }
      }
      price
      priceExcludingVat
      pricing {
        ${exports.allPricingFields}
      }
      salesPackages {
        additionalPrice
        id
        name
        equipment 
      }
      sku
      tires {
        additionalPrice
        additionalPriceExcludingVat
        description
        id
        isRecommended
        name
        nobos
        rimManufacturer
        tireManufacturer
        type
        vat
      }
    }
  }
`;
//# sourceMappingURL=vehicle.js.map